export default function EwsWarningData(currentMode, currentArea, datas) {
  const mode = currentMode;
  const area = currentArea;
  let warningData = [];

  if (datas) {
    // filter by province or basin
    if (mode === 'province' && area.code !== '0') {
      warningData = datas.item.filter((d) => d.title.indexOf(area.name) !== -1);
    } else if (mode === 'basin' && area.code !== '0') {
      warningData = datas.item.filter((d) => d.title.indexOf(area.name) !== -1);
    } else {
      warningData = datas.item;
    }

    // นับจำนวนเฝ้าระวัง
    const totalWatch = warningData.filter((d) => d.title.includes('เฝ้าระวัง')).length;

    // นับจำนวนเตือนภัย
    const totalWarning = warningData.filter((d) => d.title.includes('เตือนภัย')).length;

    // นับจำนวนอพยพ
    const totalEvacuate = warningData.filter((d) => d.title.includes('อพยพ')).length;

    const warningDatas = {
      summary: {
        watch: totalWatch,
        warning: totalWarning,
        evacuate: totalEvacuate,
      },
      item: warningData,
    };
    return warningDatas;
  }

  return null;
}
